const CONTRACT_STATUSES = ['DRAFT', 'AWAITING', 'SENT', 'SIGNED'];

export const contractStatusesObject = {
  draft: CONTRACT_STATUSES[0], // it's created but contractor did not sign it yet
  awaiting: CONTRACT_STATUSES[1], // contractor has signed it
  sent: CONTRACT_STATUSES[2], // contractor has sent it
  signed: CONTRACT_STATUSES[3], // client has signed it
};

export default CONTRACT_STATUSES;



// WEBPACK FOOTER //
// ./src/lib/constants/contractStatuses.js